// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"313":"page-index","485":"page-about","752":"page-foo-foochild"}[chunkId] || chunkId) + "." + {"313":"c3ccafa8","373":"aed020dc","485":"a06bf5a5","752":"36e90106","961":"098c6034"}[chunkId] + ".js";
};